// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3GHDQ","consentsList":"PatientConsents_consentsList__32NLw","consentsListEmpty":"PatientConsents_consentsListEmpty__1MFLy"};